import React, { useContext, useState, useEffect } from 'react'
import { useParams, useLocation } from "react-router-dom"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { Container, Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap'
import { isEmpty } from 'lodash'
import { useStripe, useElements } from '@stripe/react-stripe-js'
import { CardNumberElement } from '@stripe/react-stripe-js'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import { GeneralContext } from '../../context/'
import ApiService from '../../data/services/ApiService'
import SummaryCard from '../../components/Common/Cards/Summary'
import BankCardForm from '../../components/Common/Cards/BankCardForm'

const Checkout = (props) => {
  const stripe = useStripe()
  const elements = useElements()

  const generalContext = useContext(GeneralContext)
  const { loading, setLoading } = generalContext

  const { orderCreatedId } = useParams()
  const { state } = useLocation()

  const [cart, setCart] = useState({})
  const [cardHolderName, setCardHolderName] = useState('')

  const [confirmPayModal, setConfirmPayModal] = useState(false)
  const toggleConfirmPayModal = () => setConfirmPayModal(!confirmPayModal)

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await ApiService.getCart()
      if (!isEmpty(response.data.data)) {
        setCart(response.data.data)
      } else {
        toastr.error('Carrito inexistente.', 'Error')
        props.history.goBack()
      }
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
      props.history.goBack()
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    (async function fetch() {
      await fetchData()
    })()
  }, []) // eslint-disable-line

  useEffect(() => {
    if (isEmpty(state) || isEmpty(state.clientSecret)) {
      toastr.warning('Configuración inválida (ERR: ClSec)', 'Error')
      props.history.goBack()
    }
  }, [state]) // eslint-disable-line

  const payOrder = async () => {
    if (!stripe || !elements) {
      console.log('stripe js not loaded yet')
      toastr.error(`stripe js not loaded yet`, 'Error')
      return
    }
    try {
      toggleConfirmPayModal()
      setLoading(true)
      const result = await stripe.confirmCardPayment(state.clientSecret, {
        payment_method: {
          card: elements.getElement(CardNumberElement),
          billing_details: {
            name: cardHolderName,
          },
        }
      })
      if (result.error) {
        toastr.error(`${result.error.message}`, 'Error')
        return
      } else {
        if (result.paymentIntent.status === 'succeeded') {
          // Actualizar orden a pagado
          const orderUpdated =
            await ApiService.markeOrderAsPaid({
              orderId: orderCreatedId,
              paymentIntentId: result.paymentIntent.id,
              cardHolderName,
              cartId: cart.id,
              couponReleasedId: state.couponReleased.id,
            })
          if (orderUpdated.data.success) {
            props.history.push(`/pedido-confirmado`, {
              cart: cart,
              orderConfirmed: orderUpdated.data.order,
              settings: orderUpdated.data.settings,
              paymentMethods: orderUpdated.data.paymentMethods
            })
          }
        }
      }
    } catch (e) {
      console.log('error in pay order')
      console.log(e)
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Carrito"
            breadcrumbItem={`Pagar carrito`}
            parentLink={`/carrito`}
          />
          {!isEmpty(cart) && (
            <React.Fragment>
              <SummaryCard
                cart={cart}
                showCouponDiscount={false}
              />
              <BankCardForm
                loading={loading}
                stripe={stripe}
                cardHolderName={cardHolderName}
                setCardHolderName={setCardHolderName}
                pay={toggleConfirmPayModal}
              />
            </React.Fragment>
          )}
        </Container>
      </div>
      <div>
        <Modal isOpen={confirmPayModal} toggle={toggleConfirmPayModal}>
          <ModalHeader toggle={toggleConfirmPayModal}>Pagar pedido</ModalHeader>
          <ModalBody>
            ¿Estás segura que deseas continuar?
          </ModalBody>
          <ModalFooter>
            <Button className="btn btn-default waves-effect waves-light mb-2 mr-2" onClick={toggleConfirmPayModal}>No, Cancelar</Button>{' '}
            <Button color="primary" className="btn btn-success waves-effect waves-light mb-2 mr-2" onClick={payOrder}>Si, Confirmar</Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default Checkout
